/**
 * Log stuff to the console.
 *
 * @module app/components/Logger
 */

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {

    /**
     * Creates a new logger instance
     *
     * @returns {Function}  logging function
     *
     * @public
     */
    getLogger: function () {

        return function () {

        };
    },
};

export default api;

